import * as React from 'react'

import { Box, Icon, PaginationButton, Text } from '@factorialco/deprecated-design-system'

import usePagination from 'modules/core/components/DataTable/hooks/usePagination'
import i18n from 'modules/core/lib/i18n'

import useOffsetPages from './useOffsetPages'

const MAX_OFFSET_PAGES = 7

function ItemsIndicator() {
  const { offsetPagination, pagination } = usePagination()
  const { currentPage, totalCount: total } = offsetPagination

  if (!total) return null

  const start = (currentPage - 1) * pagination.itemsPerPage + 1
  const end = Math.min(start + pagination.itemsPerPage - 1, total)

  return (
    <Text.Normal size="200" color="grey1000">
      {i18n.t('data_table.pagination.items_indicator', { start, end, total })}
    </Text.Normal>
  )
}

function OffsetPagination() {
  const { offsetPagination } = usePagination()
  const { currentPage, goToPage, totalPages } = offsetPagination
  const pages = useOffsetPages(totalPages ?? 0, currentPage, MAX_OFFSET_PAGES, goToPage)

  if (!totalPages) return null

  const prevButtonDisabled = currentPage === 1
  const nextButtonDisabled = currentPage === totalPages

  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      gap="s24"
      width="full"
    >
      <ItemsIndicator />
      <Box
        flexDirection="row"
        gap="s6"
        justifyContent="center"
        alignItems="center"
        component="nav"
        aria-label={i18n.t('common.pagination.wrapper')}
      >
        <PaginationButton
          content={
            <Icon.Medium icon="chevron-left" color={prevButtonDisabled ? 'grey400' : 'grey600'} />
          }
          ariaLabel={i18n.t('common.pagination.previous')}
          onClick={() => goToPage(currentPage - 1)}
          disabled={prevButtonDisabled}
          nonInteractive
        />
        <Box flexDirection="row" gap="s4" alignItems="center">
          {pages.map(({ key, content, onClick, highlighted }) => (
            <Box aria-current={highlighted ? 'true' : 'false'} key={key} component="span">
              <PaginationButton
                content={content}
                ariaLabel={i18n.t('common.pagination.go_to_page', { page: content })}
                onClick={onClick}
                highlighted={highlighted}
              />
            </Box>
          ))}
        </Box>
        <PaginationButton
          content={
            <Icon.Medium icon="chevron-right" color={nextButtonDisabled ? 'grey400' : 'grey600'} />
          }
          ariaLabel={i18n.t('common.pagination.next')}
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
          nonInteractive
        />
      </Box>
    </Box>
  )
}

export default OffsetPagination
